<app-common-map
	#dataMap
	class="data-map"
	[mapId]="mapElemId"
	[mapParamsConfig]="mapParamsConfig"
	(contextmenu)="onContextmenu($event)">
</app-common-map>
<div [id]="labelContainerId" class="label-container"></div>
<div class="map-bottom-left">
	<app-address-manage-hint></app-address-manage-hint>
</div>
<div class="map-bottom-right">
	<div id="mapBdryInfo"></div>
	<app-map-legend></app-map-legend>
</div>
<app-stacked-addresses-pick></app-stacked-addresses-pick>

<!-- <div class="ol-control layer-controls">
	<button (click)="toggleLayerControl()">
		<mat-icon svgIcon="icon-layers"></mat-icon>
	</button>
</div> -->
